@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../constants/spacing.module.less';

.generated-totes-table {
  color: var(--grey-800);
  overflow-y: auto;

  [role='row'] {
    [role='cell'] {
      padding-top: @space-16;
      padding-bottom: @space-16;
      display: flex;
      align-items: flex-start;
    }
  }
}

.delete-button {
  display: flex;
  margin-right: @space-8;
  color: var(--grey-900);

  &:hover {
    color: var(--red-600);
    background-color: var(--red-50);
  }
}

.delete-icon {
  width: 14px;
  height: 14px;
}

.row-action-buttons {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.editable-input {
  width: 100%;
  color: var(--grey-900);

  input {
    border-color: var(--grey-800);
  }

  &::placeholder {
    color: var(--grey-700);
  }
}

.cell-wrapper-base {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: flex-start;
  align-items: stretch;
}

.input-cell-wrapper {
  &:extend(.cell-wrapper-base);
}

.warehouse-cell-wrapper {
  &:extend(.cell-wrapper-base);
  padding-top: @space-4;
}

.warehouse-cell-text {
  color: var(--grey-900);
  font-size: 14px;
}

.table-container {
  border: 1px solid var(--grey-300);
  border-radius: 8px;
  overflow: hidden;
}

.add-tote-row {
  border-top: 1px solid var(--grey-300);
}

.add-tote-cell-name {
  width: 300px;
  padding: @space-8 @space-12;
}

.add-tote-button {
  gap: @space-8;
  color: var(--gray-0F0F10);
  border: 1px solid var(--grey-400);

  .plus-icon {
    color: var(--gray-0F0F10);
    width: 12px;
    height: 12px;
  }
}
